module.exports = __webpack_public_path__ + "assets/mygrazz-ico-pickdate.7a780e54.svg";